"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Heading = require("../Heading");

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const PageHeader = (_ref) => {
  let { children } = _ref,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react2.default.createElement(
    _Box2.default,
    props,
    _react2.default.createElement(
      _Heading2.default,
      { as: "h1", fontSize: 3, fontWeight: 0 },
      children
    )
  );
};

PageHeader.propTypes = {
  px: _propTypes2.default.number,
  py: _propTypes2.default.number,
  children: _propTypes2.default.node
};

PageHeader.defaultProps = {
  px: 6,
  py: 4,
  borderBottom: 1,
  borderColor: "palette.ink.300"
};

exports.default = PageHeader;